import React from 'react';
import '../../styles/GroupsListPage.css';
import { FaUsers } from 'react-icons/fa'; // Icon for groups

function GroupsListPage() {
  return (
    <div className="groups-list-page">
      <div className="groups-grid">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="group-card">
            <div className="card-icon"><FaUsers size={60} color="#3f51b5" /></div>
            <h4 className="card-title">GROUP {index + 1}</h4>
          </div>
        ))}
        {/* Add more group cards as needed */}
      </div>
    </div>
  );
}

export default GroupsListPage;